import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import ReactTable from 'react-table';
import DateTimePicker from 'react-datetime';
import {
  FormGroup,
  ControlLabel,
  Col,
  Row,
  FormControl,
  Button,
} from 'react-bootstrap';
import './DeliveryHistory.css';
import PaginationTable from '../../components/Pagination/PaginationTable';
import getSortHeaderProps from '../../utils/get-sorted-headers';
import {
  Portlet,
  PortletBody,
} from '../../components/Bootstrap/Portlet';
import {
  displayDate,
  getLocaleName,
} from '../../utils/date';
import MaterialHistoryForm from './MaterialHistoryForm';
import { InventoryType } from '../../constants/MaterialModels';

@inject('shipHistoryStore', 'scheduleStore', 'materialStore', 'newAuthStore')
@observer
class DeliveryHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorted: [{id: 'date', desc: false}],
      editData: null,
    };
    this.anchor = React.createRef();
  }

  componentDidMount () {
    this.anchor.current.scrollIntoView();
  }

  getColumns = () => {
    const { sorted } = this.state;

    return [
      {
        headerText: 'Date',
        accessor: d => d,
        width: 140,
        id: 'date',
        Cell: this.renderDate,
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: 'Type',
        accessor: 'type',
        id: 'type',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: 'Truck',
        accessor: 'truck',
        id: 'truck',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: 'Vendor',
        accessor: 'vendorCode',
        id: 'vendorCode',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: 'Ticket',
        accessor: 'ticket',
        id: 'ticket',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: 'Quantity',
        accessor: d => d,
        id: 'quantity',
        ...getSortHeaderProps(sorted),
        Cell: this.renderQuantity,
      },
      {
        headerText: 'Hauler',
        accessor: 'hauler',
        id: 'hauler',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: 'BOL Ticket',
        accessor: 'bolTicket',
        id: 'bolTicket',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: 'BOL Quantity',
        accessor: 'bolQuantity',
        id: 'bolQuantity',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: 'Reason',
        accessor: d => d,
        Cell: d => (<span title={`${d.original.reasonCodeDescription}`}>{d.original.reasonCodeShortDescription}</span>),
        id: 'reasonCodeDescription',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: 'Comment',
        accessor: d => d,
        Cell: d => (<span title={`${d.original.comment}`}>{d.original.comment}</span>),
        id: 'comment',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: 'User',
        accessor: 'userName',
        id: 'userName',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: '',
        accessor: d => d,
        width: 40,
        id: 'action',
        Cell: d => (d.original.type !== InventoryType.Usage
          ? (
            <a className="btn btn-sm btn-default btn-action material-action" title={'Edit'}
              onClick={() => this.editMaterialHistory(d.original)}>
              <i className="fa fa-fw fa-pencil"/>
            </a>
          )
          : ''),
      },
    ];
  };

  editMaterialHistory(data) {
    this.setState({
      editData: data,
    });
  }

  editMaterialOnCancel() {
    this.setState({
      editData: null,
    });
  }

  editMaterialOnSubmit() {
    this.setState({
      editData: null,
    });
  }

  renderDate = rowInfo => {
    const { scheduleStore, newAuthStore } = this.props;
    const { timezone } = scheduleStore;
    const { user } = newAuthStore;

    return (
      <span>
        {displayDate(rowInfo.value.date, timezone, 'L LT', user.language)}
      </span>
    );
  };

  renderQuantity = rowInfo => {
    const material = this.props.shipHistoryStore.material;

    return (
      <span>
        {rowInfo.value.quantity}{' '}
        {material && material.itemInventoryUnitSymbol}
      </span>
    );
  };

  render() {
    const { materialStore, shipHistoryStore, newAuthStore, onClose } = this.props;
    const {
      historyItems,
      loading,
      handleChangeFilter,
      dateFrom,
      dateTo,
    } = shipHistoryStore;

    const { materialsWithHistory } = materialStore;
    const { user } = newAuthStore;
    const { editData } = this.state;

    return (
      <div ref={this.anchor}>
        <Portlet>
          <PortletBody>
            <Row className="form-header">
              <Col sm={12}>
                <a className="btn-panel-close" onClick={onClose}>x</a>
                <h4>Material History</h4>
              </Col>
            </Row>
            {!editData && (
              <Row>
                <Col sm={2}>
                  <ControlLabel>Material</ControlLabel>
                  <FormGroup>
                    <FormControl
                      name={'inventoryItemId'}
                      componentClass="select"
                      value={shipHistoryStore.historyItemId}
                      onChange={e => shipHistoryStore.showHistory(e.target.value)}
                      bsSize="sm"
                    >
                      {materialsWithHistory.map(material => (
                        <option key={material.itemId} value={material.inventoryItemId}>
                          {materialStore.getMaterialName(material)}
                        </option>
                      ))}
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col sm={2}>
                  <FormGroup>
                    <ControlLabel>Date From</ControlLabel>
                    <DateTimePicker
                      inputProps={{ className: 'form-control' }}
                      onChange={value => handleChangeFilter('dateFrom', value)}
                      timeFormat={false}
                      value={dateFrom}
                      locale={getLocaleName(user.language)}
                    />
                  </FormGroup>
                </Col>
                <Col sm={2}>
                  <FormGroup>
                    <ControlLabel>Date To</ControlLabel>
                    <DateTimePicker
                      inputProps={{ className: 'form-control' }}
                      onChange={value => handleChangeFilter('dateTo', value)}
                      timeFormat={false}
                      value={dateTo}
                      locale={getLocaleName(user.language)}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}
            {loading ? (
              <h5 className="text-center">
                <i className="fa fa-circle-o-notch fa-spin" /> Loading...
              </h5>
            ) : (
              <Row>
                <Col sm={12}>
                  {editData
                    ? (
                      <MaterialHistoryForm
                        editData={editData}
                        onCancel={() => this.editMaterialOnCancel()}
                        onSubmit={() => this.editMaterialOnSubmit()}
                      />
                    )
                    : (
                      <ReactTable
                        className="-highlight max-height-table"
                        data={historyItems.toJS()}
                        columns={this.getColumns()}
                        sorted={this.state.sorted}
                        onSortedChange={sorted => this.setState({ sorted })}
                        showPaginationTop={false}
                        showPaginationBottom={true}
                        showPageSizeOptions={true}
                        PaginationComponent={PaginationTable}
                        resizable={false}
                        minRows={1}
                        defaultPageSize={100}
                      />
                    )
                  }
                </Col>
              </Row>
            )}

            {!editData && (
              <Row>
                <Col sm={12} className="text-right">
                  <Button onClick={onClose}>Close</Button>
                </Col>
              </Row>
            )}
          </PortletBody>
        </Portlet>
      </div>
    );
  }
}

export default DeliveryHistory;
